import { Injectable } from '@angular/core';
import { CollectionReference } from '@firebase/firestore-types';
import * as firebase from 'firebase/app';
import { Page, PageSpecs, SortOrder, Filter } from '../pagination/page.model';
import { Season, SeasonData } from '../domain/season.model';
import { Member } from '../domain/member.model';


@Injectable({
  providedIn: 'root',
})
export class SeasonService {
  private seasons: CollectionReference;
  constructor() {
    this.seasons = firebase.firestore().collection("seasons")
  }

  async getCurrentSeason(): Promise<Season>{
    let snapshot = await this.seasons.orderBy('start', 'desc').limit(1).get();
    if (snapshot.size==0){
      return null;
    } else {
      return Season.of(snapshot.docs[0]);
    }
  }

  async getSeasons(member: Member){
    let snapshot = await member._snapshot.ref.collection('seasons').get();
    return snapshot.docs.map(Season.of);
  }

  async create(seasonData: SeasonData): Promise<void>{
    await this.seasons.add(seasonData);
  }

  async delete(season: Season): Promise<void>{
    return this.seasons.doc(season.id).delete();
  }

  async getLastPage(specs:PageSpecs<Filter>): Promise<Page<Season>>{
    let snapshot = await this.seasons
      .orderBy(specs.sort, specs.order==SortOrder.asc?SortOrder.desc:SortOrder.asc)
      .limit(specs.size)
      .get();
    let full = await this.seasons.get();
    let data = snapshot.docs.map(Season.of);
    return {
      _embedded: data,
      count: data.length,
      items: data.reverse(),
      current: specs.page,
      size: specs.size,
      total: full.size
    }
  }
  async getPreviousPage(page: Page<Season>, specs:PageSpecs<Filter>): Promise<Page<Season>>{
    if (specs.page==1){
      return this.getFirstPage(specs);
    } else {
      let first = await this.seasons.doc(page.items[0].id).get();
      let snapshot = await this.seasons
        .orderBy(specs.sort, specs.order)
        .endBefore(first).limit(specs.size).get();
      let data = snapshot.docs.map(Season.of);
      return {
        _embedded: data,
        count: data.length,
        items: data,
        current: specs.page,
        size: specs.size,
        total: page.total
      }
    }
  }
  async getNextPage(page: Page<Season>, specs:PageSpecs<Filter>): Promise<Page<Season>>{
    let last = await this.seasons.doc(page.items[page.items.length -1].id).get();
    let snapshot = await this.seasons.orderBy(specs.sort, specs.order).startAfter(last).limit(specs.size).get();
    let data = snapshot.docs.map(Season.of);
    return {
      _embedded: data,
      count: data.length,
      items: data,
      current: specs.page,
      size: specs.size,
      total: page.total
    }
  }
  async getFirstPage(specs:PageSpecs<Filter>): Promise<Page<Season>>{
    let snapshot = await this.seasons.orderBy(specs.sort, specs.order).limit(specs.size).get();
    let full = await this.seasons.get();
    let data = snapshot.docs.map(Season.of);
    return {
      _embedded: data,
      count: data.length,
      items: data,
      current: specs.page,
      size: specs.size,
      total: full.size
    }
  }
}
